import { observer } from "mobx-react";
import docSeriesStore from "~/stores/docSeries";
import { DocSeriesId, DocSeriesInfo } from "~/document";
import AsyncPaginatedSelect from "~/components/AsyncPaginatedCombobox";

interface Props {
  value: DocSeriesId[];
  onChange: (newValue: DocSeriesId[]) => void;
  selectProps?: any;
  // Offer only the series this user can upload a document under. Off by default, so the
  // advanced search keeps searching the full set.
  canAddDocument?: boolean;
}

const DocSeriesSelect = observer((props: Props) => {
  const { value, onChange, canAddDocument } = props;
  const idToOpt = (id: DocSeriesId) => {
    const item = docSeriesStore.f.items[id];
    if (!item) return null;
    return {
      label: item.label,
      value: item.id,
    };
  };

  return (
    <AsyncPaginatedSelect
      fetcher={docSeriesStore.f}
      itemIdToOption={idToOpt as any}
      value={value}
      onChange={onChange}
      filter={canAddDocument ? (item: DocSeriesInfo) => !!item.can_add_document : undefined}
      additionalSearchOptions={canAddDocument ? { can_add_document: "true", _page_size: "500" } : undefined}
      selectProps={{
        isMulti: true,
        ...(props.selectProps || {}),
      }}
    />
  );
});

export default DocSeriesSelect;
